import { StatusBadge } from "../status-badge";

export function StatusDiagram() {
  return (
    <div className="flex flex-1 justify-between max-w-xl mx-auto border border-r8-gray-3 p-8">
      <div className="w-full flex-1 flex items-center justify-center">
        <StatusBadge status="starting" />
      </div>
      <div className="flex-1 flex items-center">
        <div className="h-px bg-r8-gray-6 w-full" />
      </div>
      <div className="flex-1 flex items-center justify-center">
        <StatusBadge status="processing" />
      </div>
      <div className="flex-1 flex items-center">
        <div className="h-px bg-r8-gray-6 w-full" />
      </div>
      <div className="flex-1 items-center justify-center">
        <div className="flex flex-col gap-4 border-l border-r8-gray-6">
          <div className="flex items-start gap-4">
            <div className="w-24 h-px bg-r8-gray-6" />
            <div className="transform -translate-y-4">
              <StatusBadge status="succeeded" />
            </div>
          </div>
          <div className="flex items-center gap-4">
            <div className="w-24 h-px bg-r8-gray-6" />
            <StatusBadge status="failed" />
          </div>
          <div className="flex items-end gap-4">
            <div className="w-24 h-px bg-r8-gray-6" />
            <div className="transform translate-y-4">
              <StatusBadge status="canceled" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
